import React from 'react';
import './Features.scss';

class Features extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div>
                <p>Features</p>
            </div>
        )
    }
}

export default Features